import {
  BaseQueryApi,
  createApi,
  fetchBaseQuery,
} from "@reduxjs/toolkit/query/react";
import Config from "../../config";
import { authInterceptor } from "src/store/utils";
import { logout } from "src/store/slices/auth";
import { RootState } from "..";
import KEYS from "src/constants";
import { ProgramId } from "src/models/BaseModel";

async function baseQuery(
  args: any,
  api: BaseQueryApi,
  extraOptions: any,
  isPrivate: boolean,
) {
  const baseQueryApi = fetchBaseQuery({
    baseUrl:
      Config[
        String(
          (localStorage.getItem(KEYS.PROGRAM_ID) as ProgramId) ??
            ((api.getState() as RootState)?.auth.programId as ProgramId),
        ) ?? "0"
      ]?.baseUrl,
    prepareHeaders: isPrivate ? authInterceptor : undefined,
  });

  const result = await baseQueryApi(args, api, extraOptions);

  if (isPrivate && result.error && result.error.status === 401) {
    api.dispatch(logout());

    return {
      error: {
        status: 401,
        data: "Unauthorized",
      },
    };
  }

  return result;
}

const PrivateApi = createApi({
  reducerPath: "private",
  tagTypes: ["Transactions", "Tags", "Products", "Configurations"],
  baseQuery: (args, api, extraOptions) =>
    baseQuery(args, api, extraOptions, true),
  endpoints: () => ({}),
});

const PublicApi = createApi({
  reducerPath: "public",
  baseQuery: (args, api, extraOptions) =>
    baseQuery(args, api, extraOptions, false),
  endpoints: () => ({}),
});

export { PrivateApi, PublicApi };
